import { useTranslation } from 'react-i18next';
import { defaultLanguage, supportedLanguages } from './languages';

const languages = [...supportedLanguages];

/** Current UI language and a setter for the header language dropdown. The choice is cached in localStorage. */
export const useLanguage = () => {
  const { t, i18n } = useTranslation('common');
  return {
    languages,
    language: i18n.resolvedLanguage ?? defaultLanguage,
    setLanguage: (code: string) => void i18n.changeLanguage(code),
    label: t('language'),
  };
};
